import React from "react";
import { Box, Button, Typography, LinearProgress, styled } from "@mui/material";
import { BackArrowIcon } from "../../icons/BackArrowIcon";

interface JobGearHeaderProps {
  onClose: () => void;
  progress?: number;
}

const HeaderContainer = styled(Box, {
  label: "JobGearHeaderContainer",
})(() => ({
  display: "flex",
  flexDirection: "column",
}));

const HeaderContent = styled(Box, {
  label: "JobGearHeaderContent",
})(({ theme }) => ({
  display: "flex",
  alignItems: "flex-start",
  gap: theme.spacing(3),
  padding: theme.spacing(3),
}));

const ExitButton = styled(Button, {
  label: "JobGearExitButton",
})(({ theme }) => ({
  color: "#ffffff",
  border: `1px solid rgba(145, 158, 171, 0.1)`,
  borderRadius: theme.spacing(1),
  padding: theme.spacing(1, 1.5),
  minWidth: 64,
  height: 36,
  fontSize: "14px",
  fontWeight: 700,
  textTransform: "none",
  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.08)",
  },
}));

const HeaderInfo = styled(Box, {
  label: "JobGearHeaderInfo",
})(({ theme }) => ({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

const TitleSection = styled(Box, {
  label: "JobGearTitleSection",
})(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
}));

const ProgressContainer = styled(Box, {
  label: "JobGearProgressContainer",
})(() => ({
  maxWidth: "1140px",
  width: "100%",
  margin: "0 auto",
}));

const StyledLinearProgress = styled(LinearProgress, {
  label: "JobGearProgress",
})(() => ({
  height: 8,
  borderRadius: 16,
  backgroundColor: "rgba(145, 158, 171, 0.16)",
  "& .MuiLinearProgress-bar": {
    background: "linear-gradient(170.138deg, #FFD666 0%, #FFAB00 100%)",
    borderRadius: 16,
  },
}));

export const JobGearHeader = ({
  onClose,
  progress = 0,
}: JobGearHeaderProps) => {
  return (
    <HeaderContainer>
      <HeaderContent>
        <ExitButton
          variant="outlined"
          startIcon={<BackArrowIcon width={20} height={20} color="#ffffff" />}
          onClick={onClose}
        >
          Exit
        </ExitButton>

        <HeaderInfo>
          <TitleSection>
            <Typography
              variant="h4"
              sx={{
                color: "#ffffff",
                fontFamily: "Proxima Nova",
                fontWeight: 700,
                fontSize: "24px",
                lineHeight: "36px",
              }}
            >
              Job Gear
            </Typography>
          </TitleSection>
        </HeaderInfo>
      </HeaderContent>

      <ProgressContainer>
        <StyledLinearProgress variant="determinate" value={progress} />
      </ProgressContainer>
    </HeaderContainer>
  );
};
